<agr-form-dialog [formGroup]="formGroup" (confirm)="save()" (cancel)="cancel()" [data]="data">
  <div class="flex--column">
    <mat-form-field class="flex__child--auto spacing--padding-top">
      <mat-label>{{ 'departure.departure-date' | translate }}</mat-label>
      <input
        formControlName="departureDate"
        matInput
        [matDatepicker]="departureDatePicker"
        placeholder="{{ 'departure.departure-date' | translate }}"
        [min]="cycleStartDate$ | async"
        data-test="departure-item__departure-date"
      />
      <mat-datepicker-toggle matIconSuffix [for]="departureDatePicker"></mat-datepicker-toggle>
      <mat-datepicker touchUi #departureDatePicker></mat-datepicker>
      <mat-error *ngIf="formGroup.controls.departureDate.errors?.required">
        {{ 'required-error' | translate }}
      </mat-error>
      <mat-error *ngIf="formGroup.controls.departureDate.errors?.departureBeforedeparture">
        {{ 'departure.departure-before-departure-error' | translate }}
      </mat-error>
    </mat-form-field>
    <mat-form-field
      class="flex__child--auto"
      *ngIf="filteredPropagationCompanies$ | async as companies"
    >
      <mat-label>{{ 'departure.propagation-company' | translate }}</mat-label>
      <mat-select
        [hideSingleSelectionIndicator]="true"
        placeholder="{{ 'departure.propagation-company' | translate }}"
        formControlName="propagationCompany"
        data-test="departure-item__propagation-company"
        (selectionChange)="propagationCompanySelectionChanged()"
      >
        <mat-option *ngFor="let company of companies" [value]="company">
          {{ company.name }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="formGroup.controls.propagationCompany.errors?.required">
        {{ 'required-error' | translate }}
      </mat-error>
    </mat-form-field>
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'breed' | translate }}</mat-label>
      <mat-select
        [hideSingleSelectionIndicator]="true"
        placeholder="{{ 'breed' | translate }}"
        formControlName="breed"
        data-test="departure-item__breed"
        (selectionChange)="selectionChanged()"
      >
        <mat-option *ngFor="let breed of filteredBreeds$ | async" [value]="breed">{{
          breed.name
        }}</mat-option>
      </mat-select>
      <mat-error *ngIf="formGroup.controls.breed.errors?.required">
        {{ 'required-error' | translate }}
      </mat-error>
    </mat-form-field>
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'gender' | translate }}</mat-label>
      <mat-select
        [hideSingleSelectionIndicator]="true"
        placeholder="{{ 'gender' | translate }}"
        formControlName="gender"
        data-test="departure-item__gender"
        (selectionChange)="selectionChanged()"
      >
        <mat-option *ngFor="let gender of filteredGenders$ | async" [value]="gender">
          {{ gender.toString() | translate }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="formGroup.controls.gender.errors?.required">
        {{ 'required-error' | translate }}
      </mat-error>
    </mat-form-field>
    <div
      class="spacing--padding-half-all text--bold heading-wrapper spacing--padding-top spacing--padding-half-bottom"
    >
      {{ 'departure.sections' | translate }}
      <div class="border-top--gray3 horizontal-line spacing--margin-half-left"></div>
    </div>
    <p *ngIf="!!!allocations || allocations.length === 0" class="text--small text--gray">
      {{ 'departure.allocations-empty' | translate }}
    </p>
    <div class="flex__child--auto">
      <agr-table
        style="width: 500px"
        *ngIf="!!allocations && allocations.length > 0"
        [config]="allocationsTableConfig"
        data-test="allocations-table"
      >
      </agr-table>
    </div>
    <mat-error
      *ngIf="numberOfAnimalsArray.status === 'INVALID' && !numberOfAnimalsArray.errors?.required"
      class="text--small"
    >
      {{ 'departure.allocations-exceeded-error' | translate }}
    </mat-error>
    <mat-error
      *ngIf="numberOfAnimalsArray.status === 'INVALID' && numberOfAnimalsArray.errors?.required"
      class="text--small"
    >
      {{ 'departure.allocations-required-error' | translate }}
    </mat-error>
    <div
      class="spacing--padding-half-all text--bold heading-wrapper spacing--padding-top spacing--padding-half-bottom"
    >
      {{ 'departure.final-measurement' | translate }}
      <div class="border-top--gray3 horizontal-line spacing--margin-half-left"></div>
    </div>
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'departure.date-of-measurement' | translate }}</mat-label>
      <input
        formControlName="dateOfMeasurement"
        matInput
        [matDatepicker]="dateOfMeasurementDatePicker"
        (dateInput)="onDateOfMeasurementChanged($event.value)"
        placeholder="{{ 'departure.date-of-measurement' | translate }}"
        data-test="departure-item__date-of-measurement"
      />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="dateOfMeasurementDatePicker"
      ></mat-datepicker-toggle>
      <mat-datepicker touchUi #dateOfMeasurementDatePicker></mat-datepicker>
      <mat-error *ngIf="formGroup.controls.dateOfMeasurement.errors?.required">
        {{ 'required-error' | translate }}
      </mat-error>
    </mat-form-field>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'departure.weight' | translate }}</mat-label>
      <input
        matInput
        agrNumber
        formControlName="weight"
        placeholder="{{ 'departure.weight' | translate }}"
        data-test="departure-item__weight"
      />
      <mat-error *ngIf="formGroup.controls.weight.errors?.required">
        {{ 'required-error' | translate }}
      </mat-error>
    </mat-form-field>
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'departure.uniformity' | translate }}</mat-label>
      <input
        matInput
        agrNumber
        [step]="0.1"
        formControlName="uniformity"
        placeholder="{{ 'departure.uniformity' | translate }}"
        data-test="departure-item__uniformity"
      />
      <mat-error *ngIf="formGroup.controls.uniformity.errors?.required">
        {{ 'required-error' | translate }}
      </mat-error>
    </mat-form-field>
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'departure.cv-percentage' | translate }}</mat-label>
      <input
        matInput
        agrNumber
        [step]="0.1"
        formControlName="cvPercentage"
        placeholder="{{ 'departure.cv-percentage' | translate }}"
        data-test="departure-item__cv-percentage"
      />
      <mat-error *ngIf="formGroup.controls.cvPercentage.errors?.required">
        {{ 'required-error' | translate }}
      </mat-error>
    </mat-form-field>
  </div>
</agr-form-dialog>
